import { render, staticRenderFns } from "./Tranresourceslist.vue?vue&type=template&id=870daa42&"
import script from "./Tranresourceslist.vue?vue&type=script&lang=js&"
export * from "./Tranresourceslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports